import Input from "./Input";


function InputCreditCard(props) {

    const handleInputChange = (e) => {
        const input = e.replace(/\D/g, '');  // just numbers

        let formattedInput = '';
        for (let i = 0; i < input.length; i++) {
            if (i > 0 && i % 4 === 0) {  // add space 
              formattedInput += ' ';
            }
            formattedInput += input[i];
        }
        props.onChange(formattedInput);
    }

    return (
        <Input 
            {...props}
            onChange={handleInputChange}
            style={{'direction': 'ltr', 'fontSize': '14pt'}}
        />
    )
}


export default InputCreditCard;